import Lightbox from "../../../Presentation/Molecule/Lightbox/Lightbox";
import Alpine from 'alpinejs'

Alpine.data('seatplan', () => ({
    get modalElement() {
        return this.$root.querySelector('.innsbruck-lightbox');
    },

    get modalIframeElement() {
        return this.modalElement.querySelector('iframe');
    },

    openLightboxWithIframeUri(iframeUri) {
        // Don't open lightbox if Neos backend is open
        if (window.neos) {
            return;
        }

        // Ensure that iframe is empty before opening the lightbox
        this.modalIframeElement.contentWindow.document.open();
        this.modalIframeElement.contentWindow.document.write("");
        this.modalIframeElement.contentWindow.document.close();
        // Load next page in iframe
        this.modalIframeElement.setAttribute('src', iframeUri);
        // Wait 0,5 seconds before opening to reduce flickering
        setTimeout(() => {
            Lightbox.openLightbox(this.modalElement);
        }, 500)
    }
}));
